import { render, staticRenderFns } from "./mypage-navigation.vue?vue&type=template&id=22f7a24c&scoped=true&"
import script from "./mypage-navigation.vue?vue&type=script&lang=js&"
export * from "./mypage-navigation.vue?vue&type=script&lang=js&"
import style0 from "./mypage-navigation.vue?vue&type=style&index=0&id=22f7a24c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f7a24c",
  null
  
)

export default component.exports